export enum WorkflowLexicalNodeType {
  WORKFLOW_STATIC_CONTENT = 'workflowStaticContent',
  WORKFLOW_STEP_OUTPUT = 'workflowStepOutput',
  WORKFLOW_USER_INPUT = 'workflowUserInput'
}
